/**
 * MOCK PIPELINE — funnel commerciali per la modalità mock.
 *
 * Due pipeline con i rispettivi stati ordinati, ciascuna con esattamente uno
 * stato iniziale e almeno uno stato finale (vinto o perso) — il vincolo che il
 * backend impone. `kind`: 'normal'|'initial'|'won'|'lost'. Gli id sono bassi e
 * stabili: i nuovi stati creati dal form prendono id dal contatore `nextId`.
 */

import type { Pipeline } from '../../entities/pipeline/pipelineMappers';
import { MOCK_GROUP_ID } from './mockSite';

// TS-117: ogni funnel dichiara il proprio tipo. Qui entrambi sono del Preventivo, che e' l'unico
// che sa disegnarsi in bacheca finche' non arriva il Task. L'FQN e' quello registrato in
// coreEntityRegistration: se i due capi divergono, il descrittore non si risolve e la board non si
// apre (la guardia), quindi la stringa non si inventa.
const QUOTATION_FQN = 'it.dvel.crm.core.model.Quotation';
const TASK_FQN = 'it.dvel.crm.core.model.Task';

const audit = {
  companyId: 1,
  groupId: MOCK_GROUP_ID,
  userId: 1,
  userName: 'Jader Francia',
  createDate: '2026-03-01T10:00:00Z',
  modifiedDate: '2026-03-08T10:00:00Z',
};

export const mockPipelines: Pipeline[] = [
  {
    pipelineId: 1,
    name: 'Vendite dirette',
    description: 'Funnel commerciale standard per le trattative dirette',
    className: QUOTATION_FQN,
    ...audit,
    states: [
      { pipelineStateId: 101, pipelineId: 1, code: 'LEAD', description: 'Nuovo lead', kind: 'initial', position: 1, ...audit },
      { pipelineStateId: 102, pipelineId: 1, code: 'QUALIFICATO', description: 'Lead qualificato', kind: 'normal', position: 2, ...audit },
      { pipelineStateId: 103, pipelineId: 1, code: 'OFFERTA', description: 'Offerta inviata', kind: 'normal', position: 3, ...audit },
      { pipelineStateId: 104, pipelineId: 1, code: 'VINTO', description: 'Trattativa vinta', kind: 'won', position: 4, ...audit },
      { pipelineStateId: 105, pipelineId: 1, code: 'PERSO', description: 'Trattativa persa', kind: 'lost', position: 5, ...audit },
    ],
  },
  {
    pipelineId: 2,
    name: 'Post-vendita',
    description: 'Gestione delle richieste di assistenza',
    className: QUOTATION_FQN,
    ...audit,
    states: [
      { pipelineStateId: 201, pipelineId: 2, code: 'APERTO', description: 'Ticket aperto', kind: 'initial', position: 1, ...audit },
      { pipelineStateId: 202, pipelineId: 2, code: 'IN_LAVORAZIONE', description: 'In lavorazione', kind: 'normal', position: 2, ...audit },
      { pipelineStateId: 203, pipelineId: 2, code: 'RISOLTO', description: 'Ticket risolto', kind: 'won', position: 3, ...audit },
      { pipelineStateId: 204, pipelineId: 2, code: 'NON_RISOLTO', description: 'Chiuso non risolto', kind: 'lost', position: 4, ...audit },
    ],
  },
  // TS-117: un funnel di un tipo che il client NON sa ancora disegnare in bacheca. Non e' un caso
  // di prova artificioso: e' quello che succede quando il backend di un'entita' arriva prima della
  // sua schermata, o quando il plugin che la porta e' spento. Serve a tenere viva la guardia di
  // KanbanBoardPage - senza un esempio, quel ramo non lo percorre nessuno finche' non capita in
  // produzione. Quando il Task dichiarera' la propria sezione `board`, questa board iniziera' a
  // disegnarsi da sola e il mock restera' valido.
  {
    pipelineId: 3,
    name: 'Lavorazione attività',
    description: 'Funnel di attività, per ora senza bacheca disegnabile',
    className: TASK_FQN,
    ...audit,
    states: [
      { pipelineStateId: 301, pipelineId: 3, code: 'DA_FARE', description: 'Da fare', kind: 'initial', position: 1, ...audit },
      { pipelineStateId: 302, pipelineId: 3, code: 'IN_CORSO', description: 'In corso', kind: 'normal', position: 2, ...audit },
      { pipelineStateId: 303, pipelineId: 3, code: 'FATTO', description: 'Completata', kind: 'won', position: 3, ...audit },
    ],
  },
];
